import script from "./WeekScheduler.vue?vue&type=script&setup=true&lang=js"
export * from "./WeekScheduler.vue?vue&type=script&setup=true&lang=js"

import "./WeekScheduler.vue?vue&type=style&index=0&id=a0495a1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0495a1a"]])

export default __exports__